import axios from 'axios';

export default {
	install: () => {
		axios.defaults.baseURL = process.env.VUE_APP_API_URL;
	},
};
